import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { usersRoutes } from './users.routing'
import { UsersComponent } from './users.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'
import { CreateUserComponent } from './create-user/create-user.component'
import { UpdateUserComponent } from './update-user/update-user.component'
import { UserDetailsComponent } from './user-details/user-details.component'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    UsersComponent,
    CreateUserComponent,
    UpdateUserComponent,
    UserDetailsComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(usersRoutes, {
      scrollPositionRestoration: 'top',
    }),
    SweetAlert2Module.forRoot(),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [UsersComponent],
})
export class UsersModule {}
